// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-container.form-container {\n  width: 100%;\n}\n\n.search-container.form-container form img {\n  height: 20px;\n  width: 20px;\n  position: absolute;\n  top: 0;\n  right: 10px;\n  cursor: pointer;\n}\n\n.search-container.form-container form button.secondary-btn {\n  height: 42px;\n  margin-left: 10px;\n}\n\n.search-container .relative-pos {\n  display: inline;\n}\n", ""]);
// Exports
module.exports = exports;
